<script setup lang="ts">
import { useField } from 'vee-validate';
import TimePicker from './TimePicker.vue';
import type { VeeDateTimePickerProps } from '../types';
import { computed, toRef } from 'vue';
import { DateTime, Settings } from 'luxon';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeDateTimePickerProps>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, handleChange, handleBlur, meta } = useField<string | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

const { value: timeZone, handleChange: handleChangeTimeZone } = useField<string | undefined>(
  toRef(() => props.dataTimeZoneName),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

const modelValue = computed<DateTime | undefined>(() => {
  const dateTime = value.value
    ? DateTime.fromISO(value.value, { zone: timeZone.value || 'UTC' })
    : undefined;

  return dateTime?.isValid ? dateTime.setZone(Settings.defaultZone) : undefined;
});

function onUpdate(input: DateTime | undefined) {
  handleChange(input?.toISO(), meta.touched);
  handleChangeTimeZone(input?.zoneName);
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}
</script>

<template>
  <TimePicker
    v-bind="veeProps"
    :modelValue="modelValue"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  />
</template>
